/**
 * External dependencies
 */
import { useSelector } from 'react-redux';

/**
 * Internal dependencies
 */
import { Models } from '@naruto/bgdcms/src/providers/initializeModel/types';

/**
 * 描述 : 取得 Redux 內的值
 */
export default function useMappedState<T>(
  mapState: (state: Models) => T,
  equalityFn?: (left: T, right: T) => boolean
): T {
  return useSelector<Models, T>(mapState, equalityFn);
}
